import { Component, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';

export interface PositionStyles {
  top: string;
  left: string;
  right: string;
  bottom: string;
}

export type PopupPlacement = 'bottomLeft' | 'topRight' | 'bottomRight';

@Component({
  selector: 'popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.scss']
})
export class PopupComponent implements OnChanges{
  @Input() hidden = true;
  @Input() placement?: PopupPlacement;

  positions: PositionStyles = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
  }

  constructor(private el: ElementRef) { }

  ngOnChanges(changes: SimpleChanges) {
    if (!this.hidden) {
      this.open();
    }
  }

  open(): void {
    const coords = this.el.nativeElement.getBoundingClientRect();

    // reset positions
    this.positions.left = 'auto';
    this.positions.bottom = 'auto';
    this.positions.top = 'auto';
    this.positions.right = 'auto';

    switch (this.placement) {
      case 'bottomLeft':
        this.positions.left = `0`;
        this.positions.top = `${coords.height + 2}px`;
        break;
      case 'bottomRight':
        this.positions.right = `0`;
        this.positions.top = `${coords.height + 2}px`;
        break;
      default:
        this.positions.right = `0`;
        this.positions.bottom = `${coords.height + 2}px`;
        break;
    }

    this.hidden = false;
  }

  close(): void {
    this.hidden = true;
  }
}
